import { cva } from 'class-variance-authority';

export { default as BaseText } from './BaseText.vue';

export const baseTextVariants = cva(
  'c-base-text',
  {
    variants: {
      variant: {
        default: 'c-base-text--left',
        center: 'c-base-text--center',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
